<template>
                      <h2 class="titleStepForm">Employment Information</h2>
                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="font-size-14">Employment Status</h4>
                          <div class="row">
                            <div class="col-auto mb-2">
                              <label
                                for="permanentRd"
                                class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="permanent"
                                  class="inputRadioCstm d-none"
                                  id="permanentRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Permanent
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="temporaryRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="temporary"
                                  class="inputRadioCstm d-none"
                                  id="temporaryRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Temporary
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="contractRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="contract"
                                  class="inputRadioCstm d-none"
                                  id="contractRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Contract
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="slfEmplyRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="self_employed"
                                  class="inputRadioCstm d-none"
                                  id="slfEmplyRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Self-Employed
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="unemployedRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="unemployed"
                                  class="inputRadioCstm d-none"
                                  id="unemployedRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Unemployed
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="retiredRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.employStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.employStatus"
                                  value="retired"
                                  class="inputRadioCstm d-none"
                                  id="retiredRd"
                                  name="empStat"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Retired
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal2.employStatus.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal2.employStatus.$errors[0]">{{ v$.form.personal2.employStatus.$errors[0].$message }}</span></div>
  </div>
                        </div>
                        <div class="col-lg-6 mb-3">
                          <h4 class="font-size-14">Pay Frequency</h4>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="weekRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.frequencyStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.frequencyStatus"
                                  value="weekly"
                                  class="inputRadioCstm d-none"
                                  id="weekRd"
                                  name="pay_freq"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Weekly
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="fortnightRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.frequencyStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.frequencyStatus"
                                  value="fortnightly"
                                  class="inputRadioCstm d-none"
                                  id="fortnightRd"
                                  name="pay_freq"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Fortnightly
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="monthRd"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.frequencyStatus.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal2.frequencyStatus"
                                  value="monthly"
                                  class="inputRadioCstm d-none"
                                  id="monthRd"
                                  name="pay_freq"
                                /><span class="radioCircleIcon"
                                  ><i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i
                                  ><i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i
                                ></span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Monthly
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal2.frequencyStatus.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal2.frequencyStatus.$errors[0]">{{ v$.form.personal2.frequencyStatus.$errors[0].$message }}</span></div>
  </div>
                        </div>
                        <div class="col-lg-6 mb-3">
                          <div class="row">
                            <label class="font-size-14"
                              >Start Date Of Current Employment</label
                            >
                            <div class="col-6 pe-1 single-select2-cstm">
                              <Select2
                                v-model="form.personal2.user_howlong"
                                :options="selectedMonthOpt"
                                placeholder="Please Select Month"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.user_howlong.$error,
                                }"
                              />
                              <!-- Optional validation: user_howlong -->
                              <div
                                v-for="(personal2, index) in v$.form.personal2
                                  .user_howlong.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal2.$message">{{
                                  personal2.$message
                                }}</span>
                              </div>
                            </div>
                            <div class="col-6 ps-1 single-select2-cstm">
                              <Select2
                                v-model="form.personal2.user_howlong2"
                                :options="selectedYearOpt"
                                placeholder="Please Select Year"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal2.user_howlong2.$error,
                                }"
                              />

                              <div
                                v-for="(personal2, index) in v$.form.personal2
                                  .user_howlong2.$errors"
                                :key="index"
                                class="invalid-feedback"
                              >
                                <span v-if="personal2.$message">{{
                                  personal2.$message
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                          <h4 class="font-size-14">Average Monthly Income</h4>
                          <div class="row mb-12">
                            <div class="mb-2">
                              <div class="col-lg-12 single-select2-cstm">
                                <Select2 placeholder="Select average monthly income"
                                  v-model="form.personal2.averageIncm"
                                  :options="averageIncmOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.averageIncm.$error,
                                  }"
                                />
                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .averageIncm.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                          <div class="d-block">
                            <label class="font-size-14">Occupation</label>
                            <input placeholder="Enter occupation"
                              type="text"
                              v-model="form.personal2.user_occupation"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  v$.form.personal2.user_occupation.$error,
                              }"
                            />
                            <div
                              v-for="(personal2, index) in v$.form.personal2
                                .user_occupation.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal2.$message">{{
                                personal2.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                          <div class="d-block">
                            <label class="font-size-14">Employer</label>
                            <input placeholder="Enter employer name"
                              type="text"
                              v-model="form.personal2.employer"
                              class="form-control"
                              :class="{
                                'is-invalid': v$.form.personal2.employer.$error,
                              }"
                            />
                            <div
                              v-for="(personal2, index) in v$.form.personal2
                                .employer.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal2.$message">{{
                                personal2.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mb-3">
                          <div
                            class="d-block"
                            v-if="form.personal2.employStatus === 'unemployed'"
                          >
                            <label class="font-size-14">Employer's Address</label>
                            <textarea placeholder="Enter employer address"
                              type="textarea"
                              v-model="form.personal2.user_employer"
                              class="form-control resize-none"
                              rows="1"
                            ></textarea>
                          </div>
                          <div class="d-block" v-else>
                            <label class="font-size-14">Employer's Address</label>
                            <textarea placeholder="Enter employer address"
                              type="textarea"
                              v-model="form.personal2.user_employer"
                              class="form-control resize-none"
                              rows="1"
                              :class="{
                                'is-invalid':
                                  v$.form.personal2.user_employer.$error,
                              }"
                            ></textarea>
                            <div
                              v-for="(personal2, index) in v$.form.personal2
                                .user_employer.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="personal2.$message">{{
                                personal2.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <template v-if="isEdit">
                        <div class="col-lg-4 mb-3">
                          <div
                            class="d-block"
                            v-if="form.personal2.employStatus === 'unemployed'"
                          >
                            <label class="font-size-14">Work Phone No</label
                            ><span>(Numbers only)</span>
                            <div class="d-flex">
                              <div
                                class="single-select2-cstm"
                                style="min-width: 96px"
                              >
                                <Select2 placeholder="Code"
                                  v-model="form.personal2.user_w_phone_nocode"
                                  :options="countrynameIssuanceOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_nocode
                                        .$error,
                                  }"
                                >
                                </Select2>
                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_nocode.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                              <div class="d-block">
                                <input placeholder="Enter work phone number"
                                  type="number"
                                  v-model="form.personal2.user_w_phone_no"
                                  class="form-control"
                                  inputmode="numeric"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="d-block" v-else>
                            <label class="font-size-14">Work Phone No</label
                            ><span>(Numbers only)</span>
                            <div class="d-flex">
                              <div
                                class="single-select2-cstm"
                                style="min-width: 96px"
                              >
                                <Select2 placeholder="Code"
                                  v-model="form.personal2.user_w_phone_nocode"
                                  :options="countrynameIssuanceOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_nocode
                                        .$error,
                                  }"
                                >
                                </Select2>
                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_nocode.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                              <div class="d-block">
                                <input
                                  type="number"
                                  v-model="form.personal2.user_w_phone_no"
                                  placeholder="No dashes or spaces"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_no.$error,
                                  }"
                                  @input="validatemobnumber2"
                                  inputmode="numeric"
                                />
                                <div class="invalid-feedback"
                                  v-if="ispassnumberInvalid"
                                  >Atleast 7 number required</div>

                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_no.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </template>
                        <template v-if="!isEdit">
                        <!-- Optional validation: user_w_phone_no -->
                        <div class="col-lg-6 mb-3">
                          <div
                            class="d-block"
                            v-if="form.personal2.employStatus === 'unemployed'"
                          >
                            <label class="font-size-14">Work Phone No</label
                            ><span>(Numbers only)</span>
                            <div class="d-flex">
                              <div
                                class="single-select2-cstm"
                                style="min-width: 96px"
                              >
                                <Select2 placeholder="Code"
                                  v-model="form.personal2.user_w_phone_nocode"
                                  :options="countrynameIssuanceOpt"
                                >
                                </Select2>
                                <div
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_nocode
                                        .$error,
                                  }"
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_nocode.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                              <div class="d-block">
                                <input placeholder="Enter work phone number"
                                  type="number"
                                  v-model="form.personal2.user_w_phone_no"
                                  class="form-control"
                                  inputmode="numeric"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="d-block" v-else>
                            <label class="font-size-14">Work Phone No</label
                            ><span>(Numbers only)</span>
                            <div class="d-flex">
                              <div
                                class="single-select2-cstm"
                                style="min-width: 96px"
                              >
                                <Select2 placeholder="Code"
                                  v-model="form.personal2.user_w_phone_nocode"
                                  :options="countrynameIssuanceOpt"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_nocode
                                        .$error,
                                  }"
                                >
                                </Select2>
                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_nocode.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                              <div class="d-block col-lg-8">
                                <input
                                  type="number"
                                  v-model="form.personal2.user_w_phone_no"
                                  placeholder="No dashes or spaces"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal2.user_w_phone_no.$error,
                                  }"
                                  @input="validatemobnumber2"
                                  inputmode="numeric"
                                />
                                <div class="invalid-feedback"
                                  v-if="ispassnumberInvalid"
                                  >Atleast 7 number required</div>

                                <div
                                  v-for="(personal2, index) in v$.form.personal2
                                    .user_w_phone_no.$errors"
                                  :key="index"
                                  class="invalid-feedback"
                                >
                                  <span v-if="personal2.$message">{{
                                    personal2.$message
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </template>
                        <template v-if="!isEdit">
                        <!-- Optional UI element -->
                        </template>
                        <div class="col-lg-6 mb-3">
                          <div class="d-block">
                            <label class="font-size-14"
                              >Ext. <sup>(if any)</sup></label
                            >
                            <input placeholder="Enter extension"
                              type="number"
                              inputmode="numeric"
                              v-model="form.personal2.user_phone_no"
                              class="form-control"
                              @input="validatemobnumber3"
                            />
                            <!-- <div class="invalid-feedback" v-if="ispassnumberInvalid2">Atleast 9 number required</div> -->
                            <!-- Optional validation: user_phone_no -->
                          </div>
                        </div>
                        <div class="col-12 mb-3">
                          <div class="d-block">
                            <label class="font-size-14"
                              >School
                              <sup>(if applicant is a student)</sup></label
                            >
                            <textarea placeholder="Enter school / institution name"
                              type="textarea"
                              v-model="form.personal2.user_isstudent"
                              class="form-control resize-none"
                              rows="1"
                            ></textarea>
                            <!-- Optional validation: user_isstudent -->
                          </div>
                        </div>
                      </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";

export default {
  name: "EmploymentStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["selectedYearOpt", "selectedMonthOpt", "averageIncmOpt", "countrynameIssuanceOpt", "form", "ispassnumberInvalid", "ispassnumberInvalid2"],
    methods: ["validatemobnumber2", "validatemobnumber3"],
    validate: true,
    }),
  ],
  components: { Select2 },
};
</script>